import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'textarea[appAutoResize]',
    standalone: false
})
export class AutoResizeDirective {
  private readonly maxHeight: number;

  constructor(private el: ElementRef) {
    // Calcula a altura máxima baseada em 8 linhas
    const lineHeight = parseFloat(getComputedStyle(this.el.nativeElement).lineHeight);
    this.maxHeight = lineHeight * 8;
  }

  @HostListener('input') onInput() {
    this.adjustHeight();
  }

  private adjustHeight() {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;

    if (textarea.scrollHeight > this.maxHeight) {
      textarea.style.height = `${this.maxHeight}px`;
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }
  }
}